module.exports = __webpack_public_path__ + "img/pdf.1085473c.png";